import { gql } from '@apollo/client';

export const UNREAD_MESSAGES_COUNT = gql`
  query unreadMessagesCount {
    unreadMessagesCount
  }
`;
